import Request from './request'

const SpecificationItems  = {
  updatePositionInSpecification(id, params, callback) {
    Request.put('client-order-spec-items/' + id, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
}

export default SpecificationItems
